import { BALANCE_CONSUMED_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { fetchConsumedBalanceByCustomerFailure, fetchConsumedBalanceByCustomerSuccess } from "./reducer"

export const fetchConsumedBalanceByCustomer = (setLoading, customerId) => async (dispatch) => {
    setLoading(true)
    const graphqlQuery = {
        query: "query ConsumedBalanceByCustomer($customerId: String!) {\n  ConsumedBalanceByCustomer(customerId: $customerId) {\n    consumedbalance\n  } \n}",
        variables: { customerId: customerId}
    }

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            `${BALANCE_CONSUMED_API}`,
            'POST',
            graphqlQuery
        );
        setLoading(true)
        const ConsumedBalanceByCustomer = response?.data?.ConsumedBalanceByCustomer
        dispatch(fetchConsumedBalanceByCustomerSuccess(ConsumedBalanceByCustomer))
    } catch (error) {
        dispatch(fetchConsumedBalanceByCustomerFailure(error.message))
    } finally {
        setLoading(false)
    }
}

